import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { custApi } from "@/lib/api";

const CustomerContext = createContext(null);
export const useCustomer = () => useContext(CustomerContext);

export function CustomerProvider({ children }) {
  const [customer, setCustomer] = useState(null); // null=loading, false=unauth, object=auth

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("mc_customer_token");
    if (!token) { setCustomer(false); return false; }
    try {
      const { data } = await custApi.get("/customer/me");
      setCustomer(data);
      return data;
    } catch (e) {
      localStorage.removeItem("mc_customer_token");
      setCustomer(false);
      return false;
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = useCallback(async (slug, identifier, password) => {
    const { data } = await custApi.post(`/t/${slug}/customer/login`, { identifier, password });
    localStorage.setItem("mc_customer_token", data.token);
    await refresh();
  }, [refresh]);

  const register = useCallback(async (slug, payload) => {
    const { data } = await custApi.post(`/t/${slug}/customer/register`, payload);
    localStorage.setItem("mc_customer_token", data.token);
    await refresh();
  }, [refresh]);

  const logout = useCallback(() => {
    localStorage.removeItem("mc_customer_token");
    setCustomer(false);
  }, []);

  return (
    <CustomerContext.Provider value={{ customer, refresh, login, register, logout }}>
      {children}
    </CustomerContext.Provider>
  );
}
